export function getMesAno() {
  var t = new Date()
  var m = t.getMonth().toString()
  if (m.length < 2) m = '0' + m
  var a = t.getFullYear().toString()
  return m + a
}